import { useQuery } from "@tanstack/react-query";

import { quoteRequestLineActivePredictionQuery } from "#modules/quoteRequestLines/infra/quoteRequestLineActivePrediction.query";

export const useQuoteRequestLineActivePrediction = (id: string | undefined) => {
  const { data, ...rest } = useQuery({
    ...quoteRequestLineActivePredictionQuery(id),
  });

  return { prediction: data, ...rest };
};
